import { render, staticRenderFns } from "./DeliveryNotesInfo.vue?vue&type=template&id=35312fa4&scoped=true&"
import script from "./DeliveryNotesInfo.vue?vue&type=script&lang=js&"
export * from "./DeliveryNotesInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryNotesInfo.vue?vue&type=style&index=0&id=35312fa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35312fa4",
  null
  
)

export default component.exports